import axios from 'axios';

const attributeService = {
 
  // isOnlyVariant: true gönderilirse backend sadece gerçek varyant adlarını döner (ProductAttribute
  // Varyantible=1 üzerinden), karışık gelen değerleri (ör. "KREM", "YEŞİL") dışarıda bırakır.
  // isGroupValue: true gönderilirse backend attribute ADI yerine attribute DEĞERLERİNİ
  // (AttributeValue.Name) döner - "Bizim Değerimiz" gibi değer seçimi gereken yerler için.
  fetchAttribute: async (userId, token, isOnlyVariant, isGroupValue) => {
    try {
      const response = await axios.get('/Attribute', {
        params: {
          isGroupName: isGroupValue ? undefined : true,
          IsGroupValue: isGroupValue || undefined,
          UserId: userId,
          IsOnlyVariant: isOnlyVariant || undefined,
        },
        headers:{
          Authorization: `Bearer ${token}`
        }
      });
      return response?.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },
 
}
export default attributeService;
